import React, { useRef, useState, useLayoutEffect } from 'react'

interface Props {
  text: React.ReactNode
  isTruncated: boolean
}

function TooltipText({ text, isTruncated }: Props) {
  const [showTooltip, setShowTooltip] = useState(false)
  const [isActuallyTruncated, setIsActuallyTruncated] = useState(false)
  const textRef = useRef<HTMLSpanElement>(null)
  const timerRef = useRef<NodeJS.Timeout>()

  useLayoutEffect(() => {
    if (textRef.current && isTruncated) {
      const el = textRef.current
      setIsActuallyTruncated(el.scrollWidth > el.offsetWidth)
    } else {
      setIsActuallyTruncated(false)
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [text, isTruncated])

  const handleMouseEnter = () => {
    setShowTooltip(true)
    timerRef.current = setTimeout(() => {
      if (textRef.current && isTruncated) {
        setIsActuallyTruncated(
          textRef.current.scrollWidth > textRef.current.offsetWidth
        )
      }
    }, 50)
  }

  const handleMouseLeave = () => {
    setShowTooltip(false)
    if (timerRef.current) clearTimeout(timerRef.current)
  }

  return (
    <span
      className="tooltip-text"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span
        ref={textRef}
        className={isTruncated ? 'tooltip-text__truncate' : ''}
      >
        {text}
      </span>

      {isActuallyTruncated && showTooltip && (
        <span className="tooltip-text__text">{text}</span>
      )}
    </span>
  )
}

export default TooltipText
